<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Header -->
    <div class="bg-white shadow">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div class="flex items-center justify-between">
          <div>
            <h1 class="text-3xl font-bold text-gray-900 flex items-center gap-2">
              Admin Dashboard
              <BaseInfoIcon :text="ERKLAERUNG.adminDashboard" label="Admin Dashboard" :oben="false" />
            </h1>
            <p class="mt-1 text-sm text-gray-600">
              Manage micro-credentials, user assignments and Discord servers
            </p>
          </div>
          <div class="flex items-center space-x-4">
            <span class="inline-flex items-center rounded-full bg-red-100 px-3 py-1 text-sm font-medium text-red-700">
              Admin Access
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <!-- Tab Navigation -->
      <div class="mb-6 border-b border-gray-200">
        <nav class="-mb-px flex space-x-8">
          <button
            @click="activeTab = 'credentials'"
            :class="[
              'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
              activeTab === 'credentials'
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            ]"
          >
            Micro-Credentials
          </button>
          <button
            @click="activeTab = 'assignments'"
            :class="[
              'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
              activeTab === 'assignments'
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            ]"
          >
            User Assignments
          </button>
          <button
            @click="activeTab = 'duplication'"
            :class="[
              'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
              activeTab === 'duplication'
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            ]"
          >
            Data Duplication
          </button>
          <button
            @click="activeTab = 'discord'"
            :class="[
              'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
              activeTab === 'discord'
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            ]"
          >
            Discord-Server
          </button>
        </nav>
      </div>

      <!-- Tab Content -->
      <div class="mt-6">
        <MicroCredentialList v-if="activeTab === 'credentials'" />
        <UserCredentialAssignment v-if="activeTab === 'assignments'" />
        <DataDuplication v-if="activeTab === 'duplication'" />
        <DiscordServerZuordnung v-if="activeTab === 'discord'" />
      </div>
    </div>
  </div>
</template>

<script>
import MicroCredentialList from './MicroCredentialList.vue';
import UserCredentialAssignment from './UserCredentialAssignment.vue';
import DataDuplication from './DataDuplication.vue';
import DiscordServerZuordnung from './DiscordServerZuordnung.vue';
import BaseInfoIcon from '@/BaseComponents/BaseInfoIcon.vue';
import { ERKLAERUNG } from '@/async-sessions/erklaerungen';

export default {
  name: 'AdminDashboard',
  components: {
    MicroCredentialList,
    UserCredentialAssignment,
    DataDuplication,
    DiscordServerZuordnung,
    BaseInfoIcon,
  },
  data() {
    return {
      ERKLAERUNG,
      activeTab: 'credentials', // 'credentials', 'assignments', 'duplication' or 'discord'
    };
  },
};
</script>
